import { RESET_PASSWORD_I18N_KEYS } from '../../../../features/login/constants/i18n/resetPasswordi18nConstants';

export const RESET_PASSWORD_I18N_EN = {
  [RESET_PASSWORD_I18N_KEYS.title]:                                 "Reset Password",
  [RESET_PASSWORD_I18N_KEYS.new_password]:                          "New Password",
  [RESET_PASSWORD_I18N_KEYS.re_enter_new_password]:                 "Re-Enter New Password",
  [RESET_PASSWORD_I18N_KEYS.password_mismatch]:                     "Password mismatch",
  [RESET_PASSWORD_I18N_KEYS.password_does_not_meet_requirements]:   "Password must be at least 8 characters long. Password must include 1 uppercase letter, 1 lowercase letter, and 1 digit.",
  [RESET_PASSWORD_I18N_KEYS.submit]:                                "Reset Password",
  [RESET_PASSWORD_I18N_KEYS.unknown_error_when_resetting_password]: "Unknown error when resetting password",
  [RESET_PASSWORD_I18N_KEYS.reset_token_error]:                     "Invalid token. Please check reset password link.",
  [RESET_PASSWORD_I18N_KEYS.password_reset_successfully]:           "Password reset successfully. Redirecting to login page..."
}


// WEBPACK FOOTER //
// ./src/locales/en/features/login/reset_password.i18n.en.js